import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import { FiMail, FiPhone, FiMapPin, FiGithub, FiLinkedin, FiTwitter, FiGlobe } from 'react-icons/fi';
import './Footer.scss';

const Footer: React.FC = () => {
  const colors = useThemeColors();

  return (
    <footer 
      className="footer"
      style={{ 
        backgroundColor: colors.surface,
        color: colors.primary,
        borderTop: `1px solid ${colors.border}`
      }}
    >
      <div className="footer__container">
        {/* Contact Information */}
        <div className="footer__section">
          <h3 className="footer__title">Contact Me</h3>
          <ul className="footer__contact-list">
            <li className="footer__contact-item">
              <FiMail className="footer__icon" />
              <a href="mailto:anandhpradeep909@gmail.com">anandhpradeep909@gmail.com</a>
            </li>
            <li className="footer__contact-item">
              <FiPhone className="footer__icon" />
              <a href="tel:+919894016217">+91-9894016217</a>
            </li>
            <li className="footer__contact-item">
              <FiMapPin className="footer__icon" />
              <span>India</span>
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer__section">
          <h3 className="footer__title">Quick Navigation</h3>
          <ul className="footer__links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#education">Education</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Social Media & Professional Links */}
        <div className="footer__section">
          <h3 className="footer__title">Connect With Me</h3>
          <div className="footer__socials">
            <a 
              href="https://linkedin.com/in/yourprofile" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FiLinkedin className="footer__social-icon" />
            </a>
            <a 
              href="https://github.com/yourusername" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FiGithub className="footer__social-icon" />
            </a>
            <a 
              href="https://twitter.com/yourhandle" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FiTwitter className="footer__social-icon" />
            </a>
            <a 
              href="https://yourportfolio.com" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Portfolio"
            >
              <FiGlobe className="footer__social-icon" />
            </a>
          </div>
          
          <div className="footer__availability">
            <span className="footer__availability-badge">Open to Opportunities</span>
            <p className="footer__availability-text">
              Currently available for full-time and contract roles
            </p>
          </div>
        </div>
      </div>

      {/* Copyright & Legal */}
      <div 
        className="footer__copyright"
        style={{ 
          backgroundColor: colors.background,
          color: colors.secondary
        }}
      >
        <div className="footer__copyright-container">
          <p>© {new Date().getFullYear()} Anantha Pradeep N. All rights reserved.</p>
          <div className="footer__legal-links">
            <a href="/privacy">Privacy Policy</a>
            <span>|</span>
            <a href="/terms">Terms of Service</a>
            <span>|</span>
            <a href="/sitemap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;